import { addDisplayName, addHandlers, addState, flowMax } from 'ad-hok'
import saveAs from 'file-saver'
import { FC } from 'react'
import { addApi } from 'shared/src/api'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { Button } from './Button'
import { Page } from './Page'

export const Misc: FC = flowMax(
  addDisplayName('Misc'),
  addState('isExporting', 'setExporting', false),
  addApi,
  addTranslationHelpers,
  addHandlers({
    onExport:
      ({ api, setExporting }) =>
      async () => {
        setExporting(true)

        try {
          const response = await api.exportBookmarks()
          const blob = await response.blob()
          saveAs(blob, 'bookmarks.csv')
        } catch (error) {
          alert('Error exporting bookmarks')
        } finally {
          setExporting(false)
        }
      },
  }),
  ({ onExport, isExporting, t }) => (
    <Page>
      <Button
        text={t('admin.misc.exportBookmarks')}
        onClick={onExport}
        disabled={isExporting}
      />
    </Page>
  )
)
